const getters = {
  getBenefitTypes: (state) => state.benefitTypes,
  getBenefitType: (state) => state.benefitType,
};

export default getters;